import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const minMenuWidth = 75;
const maxMenuWidth = 180;

const initialSideBarWidth = 320;
const minSideBarWidth = 180;
const maxSideBarWidth = 860;

const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
  // Use default state
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [sideBarWidth, setSideBarWidth] = useState(initialSideBarWidth);

  const toggleMenu = () => {
    setIsMenuExpanded(prev => !prev);
  };

  const resizeSideBar = (newWidth) => {
    setSideBarWidth(Math.min(Math.max(newWidth, minSideBarWidth), maxSideBarWidth));
  };

  const value = {
    minMenuWidth,
    maxMenuWidth,
    isMenuExpanded,
    setIsMenuExpanded,
    toggleMenu,
    sideBarWidth,
    resizeSideBar,
  };

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};

LayoutProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

export default LayoutContext;
